import { Box, Button, Stack } from "@mui/material";

interface IProcessManagerButtonsProps {
  HANDLE_STARTING_CLICK?: () => void;
  HANDLE_FINISHING_CLICK?: () => void;
  IS_STARING_STEP?: boolean;
}

export const ProcessManagerButtons = (props: IProcessManagerButtonsProps) => {
  const { HANDLE_STARTING_CLICK, HANDLE_FINISHING_CLICK, IS_STARING_STEP } = props;

  return (
    <Stack sx={{ width: IS_STARING_STEP ? "100%" : "82%", display: "flex", alignItems: "center" }}>
      <Box sx={{ display: "flex", flexDirection: "column", width: "150px", gap: 1 }}>
        <Button
          id="confirm-button"
          onClick={HANDLE_STARTING_CLICK}
          color={"primary"}
          variant="contained"
          autoFocus
          disabled={!HANDLE_STARTING_CLICK}
        >
          {IS_STARING_STEP ? "Get Started" : "Finish"}
        </Button>
        {IS_STARING_STEP && HANDLE_FINISHING_CLICK && (
          <Button id="confirm-button" onClick={HANDLE_FINISHING_CLICK} color={"primary"} variant="text" autoFocus>
            Skip
          </Button>
        )}
      </Box>
    </Stack>
  );
};
